<template>
  <div class="h-full w-full mx-auto p-6">
    <div class="bg-white shadow-lg rounded-lg w-full h-full overflow-hidden">
      <div class="w-full h-full flex overflow-auto">
        <template v-if="!showUserGallery">
          <div class="w-full max-h-full px-4 py-4">
            <div
              class="grid gap-2 lg:gap-4 grid-cols-2 lg:grid-cols-5 z-50 pb-4"
            >
              <template v-for="(user, index) in users">
                <div
                  class="border-2 shadow-md rounded flex flex-col justify-center items-center py-2"
                  :key="'userCard' + index"
                >
                  <v-lazy-image
                    :src="replaceURL(user.profile_image)"
                    class="rounded-full object-cover"
                    style="width: 96px; height: 96px"
                  />
                  <div class="flex flex-col py-2">
                    <span-s-styled
                      class="text-sm font-semibold"
                      :colorS="color_secundario"
                    >
                      {{ user.nombre }} {{ user.apellido }}
                    </span-s-styled>
                    <span-t-styled
                      class="text-base font-bold tracking-wider"
                      :colorT="color_terciario"
                    >
                      {{ user.qty_levantamientos }} ficha(s)
                    </span-t-styled>
                  </div>
                  <div class="flex flex-col text-xs space-y-1">
                    <a
                      :href="replaceURLMapByUser(user)"
                      target="_blank"
                      class="font-semibold"
                      >Ver fotos en mapa</a
                    >
                    <a
                      @click="showGallery(user)"
                      class="font-semibold cursor-pointer"
                      >Ver fotos en galería</a
                    >
                  </div>
                </div>
              </template>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="flex flex-col lg:flex-row w-full max-h-full px-4 py-4">
            <div
              class="w-11/12 lg:w-1/6 mx-auto border-2 shadow-md rounded flex flex-col justify-center items-center pt-12 lg:py-2 mb-2 relative"
            >
              <v-lazy-image
                :src="replaceURL(selectedUser.profile_image)"
                class="rounded-full object-cover"
                style="width: 96px; height: 96px"
              />
              <div class="flex flex-col py-2">
                <span-s-styled
                  class="text-sm font-semibold"
                  :colorS="color_secundario"
                >
                  {{ selectedUser.nombre }} {{ selectedUser.apellido }}
                </span-s-styled>
                <span-t-styled
                  class="text-base font-bold tracking-wider"
                  :colorT="color_terciario"
                >
                  {{ selectedUser.qty_levantamientos }} ficha(s)
                </span-t-styled>
              </div>
              <div class="flex flex-col text-xs space-y-1">
                <a
                  :href="replaceURLMapByUser(selectedUser)"
                  target="_blank"
                  class="font-semibold"
                  >Ver fotos en mapa</a
                >
              </div>

              <button-styled
                class="absolute inset-x-0 top-0 text-white px-4 py-2 rounded"
                @click="hideGallery()"
                :colorT="color_terciario"
              >
                Regresar
              </button-styled>
            </div>
            <gallery-grid
              :multimedia="listGalleryMultimedia"
              :colorP="color_principal"
              :colorS="color_secundario"
              :colorT="color_terciario"
            ></gallery-grid>
          </div>
        </template>
      </div>
    </div>
  </div>
</template>

<script>
import urlMixin from "@/mixins/urlMixin";
import axios from "axios";

import GalleryGrid from "./GalleryGrid";


import { styled } from "@egoist/vue-emotion";

// Nombre de días...
const weekday = new Array(7);
weekday[0] = "Dom";
weekday[1] = "Lun";
weekday[2] = "Mar";
weekday[3] = "Mie";
weekday[4] = "Jue";
weekday[5] = "Vie";
weekday[6] = "Sáb";

// Nombres de meses...
const month = new Array();
month[0] = "Ene";
month[1] = "Feb";
month[2] = "Mar";
month[3] = "Abr";
month[4] = "May";
month[5] = "Jun";
month[6] = "Jul";
month[7] = "Ago";
month[8] = "Sep";
month[9] = "Oct";
month[10] = "Nov";
month[11] = "Dic";

const SpanSStyled = styled("span")`
  color: ${(props) => props.colorS};
`;

const SpanTStyled = styled("span")`
  color: ${(props) => props.colorT};
`;

const ButtonStyled = styled("button")`
  background-color: ${(props) => props.colorT};
`;

export default {
  mixins: [urlMixin],
  name: "UserGallery",
  data: function () {
    return {
      config: {
        headers: {
          "x-access-token": localStorage.getItem("accessToken"),
        },
      },
      users: [],
      showUserGallery: false,
      selectedUser: {},
      listGalleryMultimedia: [],
      category: window.atob(localStorage.getItem("category")),
      color_principal: "",
      color_secundario: "",
      color_terciario: "",
    };
  },
  components: {
    GalleryGrid,
    SpanSStyled,
    SpanTStyled,
    ButtonStyled,
  },
  mounted() {
    this.getUserList();
  },
  methods: {
    getUserList() {
      axios
        .post(
          "apidev/levantamientos/getUsersByLevantamientos",
          {
            usuario_id: localStorage.getItem("user_id"),
            category: this.category,
          },
          this.config
        )
        .then((response) => {
          this.users = response.data.statistics;
          // removed console log
        })
        .catch((error) => {
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
          this.$root.$emit("hideLoading");
        });
    },
    showGallery(user) {
      this.$root.$emit("showLoading");

      axios
        .post(
          "apidev/levantamientos/getLevantamientosDeUsuario",
          {
            email: user.email,
            category: this.category,
          },
          this.config
        )
        .then((response) => {
          let listaLevantamientos = response.data.levantamientos;

          listaLevantamientos.forEach((levantamiento) => {
            if (levantamiento.media_array !== null) {
              let multimediaArray = JSON.parse(levantamiento.media_array);
              multimediaArray.forEach((multimedia) => {
                multimedia.usuario_id = levantamiento.usuario_id;
                multimedia.nombre = levantamiento.title;
                multimedia.nombre_usuario = levantamiento.nombre_usuario;
                multimedia.apellido_usuario = levantamiento.apellido_usuario;
                let TDate = new Date(levantamiento.fecha_levantamiento);
                TDate =
                  weekday[TDate.getDay()] +
                  " " +
                  TDate.getDate() +
                  " de " +
                  month[TDate.getMonth()] +
                  " de " +
                  TDate.getFullYear();
                multimedia.TDate = TDate;
                multimedia.id = levantamiento.id;
                multimedia.latitud = levantamiento.latitud;
                multimedia.longitud = levantamiento.longitud;
                this.listGalleryMultimedia.push(multimedia);
                //}
              });
            }
          });

          this.selectedUser = user;
          this.showUserGallery = true;
          this.$root.$emit("hideLoading");
        })
        .catch((error) => {
          this.$root.$emit("hideLoading");
          // removed console log
          this.showingError = false;
        });
    },
    hideGallery() {
      this.$root.$emit("showLoading");
      this.listGalleryMultimedia = [];
      this.selectedUser = {};
      this.showUserGallery = false;
      this.$root.$emit("hideLoading");
    },
    replaceURLMapByUser(register) {
      return `../../levantamientos/${register.user_id}`;
    },
    fetchConfiguration() {
      this.axios
        .get("apidev/api/config/site")
        .then((response) => {
          let conf = response.data.config;
          /* this.url_image = conf.url_image; */
          this.color_principal = conf.color_principal;
          this.color_secundario = conf.color_secundario;
          this.color_terciario = conf.color_terciario;
        })
        .catch((error) => {
          // removed console log
          if (error.response.status == 400 || error.response.status == 401) {
            if (
              error.response.data.name === "TokenExpiredError" ||
              error.response.data.name === "InvalidTokenError" ||
              error.response.data.name === "JsonWebTokenError"
            ) {
              this.$router.push({ path: "/login" });
            }
          }
        });
    },
  },
  beforeMount() {
    this.fetchConfiguration();
  },
};
</script>
